import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import overviewIconOn from '../../images/components/content_summary/overview_icon_on.svg';
import overviewIconOff from '../../images/components/content_summary/overview_icon_off.svg';
import componentIconOn from '../../images/components/content_summary/component_icon_on.svg';
import componentIconOff from '../../images/components/content_summary/component_icon_off.svg';
import securityIconOn from '../../images/components/content_summary/security_icon_on.svg';
import securityIconOff from '../../images/components/content_summary/security_icon_off.svg';
import licenseIconOn from '../../images/components/content_summary/license_icon_on.svg';
import licenseIconOff from '../../images/components/content_summary/license_icon_off.svg';
import policyIconOn from '../../images/components/content_summary/policy_icon_on.svg';
import policyIconOff from '../../images/components/content_summary/policy_icon_off.svg';

class HeaderLinkDetail extends Component {
  render() {
    const activeClassName = 'active';
    const {
      t, location, overviewSummary, props
    } = this.props;
    const { subMenu } = overviewSummary;

    if (!overviewSummary.subMenu) {
      return;
    }

    return (
      <nav className="result_header_menu">
        <NavLink
          to={`overview/binary/${location.pathname && location.pathname.replace(
            /^\D+/g,
            ''
          )}`}
          onClick={() => {
            props.state.user.setTransientNavigationState({ navigatedFromTab: true });
          }}
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
          end
        >
          <p className="icon">
            <img className="on" src={overviewIconOn} alt="Overview" />
            <img className="off" src={overviewIconOff} alt="Overview" />
          </p>
          <p className="menu_name">{t('panel.menu.overview')}</p>
        </NavLink>
        {subMenu.component && subMenu.component !== 0 ? (
          <NavLink
            to={`component/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            onClick={() => {
              props.state.user.setTransientNavigationState({ navigatedFromTab: true });
            }}
            className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
            end
          >
            <p className="icon">
              <img className="on" src={componentIconOn} alt="Component" />
              <img className="off" src={componentIconOff} alt="Component" />
            </p>
            <p className="menu_name">{t('panel.menu.component')}</p>
          </NavLink>
        ) : (
          <NavLink
            to={`component/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            className={() => { return undefined; }}
            style={{ pointerEvents: 'none' }}
            end
          >
            <p className="icon">
              <img className="on" src={componentIconOn} alt="Component" />
              <img className="off" src={componentIconOff} alt="Component" />
            </p>
            <p className="menu_name">{t('panel.menu.component')}</p>
          </NavLink>
        )}
        {subMenu.security && subMenu.security !== 0 ? (
          <NavLink
            to={`security/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            onClick={() => {
              props.state.user.setTransientNavigationState({ navigatedFromTab: true });
            }}
            end
            className={() => {
              const shouldBeActive = location.pathname.startsWith('/results/security/');
              return shouldBeActive ? activeClassName : undefined;
            }}
          >
            <p className="icon">
              <img className="on" src={securityIconOn} alt="Security" />
              <img className="off" src={securityIconOff} alt="Security" />
            </p>
            <p className="menu_name">{t('panel.menu.security')}</p>
          </NavLink>
        ) : (
          <NavLink
            to={`security/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            className={() => { return undefined; }}
            style={{ pointerEvents: 'none' }}
            end
          >
            <p className="icon">
              <img className="on" src={securityIconOn} alt="Security" />
              <img className="off" src={securityIconOff} alt="Security" />
            </p>
            <p className="menu_name">{t('panel.menu.security')}</p>
          </NavLink>
        )}
        {subMenu.license && subMenu.license !== 0 ? (
          <NavLink
            to={`license/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            onClick={() => {
              props.state.user.setTransientNavigationState({ navigatedFromTab: true });
            }}
            className={() => {
              const shouldBeActive = location.pathname.startsWith('/results/license/');
              return shouldBeActive ? activeClassName : undefined;
            }}
            end
          >
            <p className="icon">
              <img className="on" src={licenseIconOn} alt="License" />
              <img className="off" src={licenseIconOff} alt="License" />
            </p>
            <p className="menu_name">{t('panel.menu.license')}</p>
          </NavLink>
        ) : (
          <NavLink
            to={`license/binary/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            className={() => { return undefined; }}
            style={{ pointerEvents: 'none' }}
            end
          >
            <p className="icon">
              <img className="on" src={licenseIconOn} alt="License" />
              <img className="off" src={licenseIconOff} alt="License" />
            </p>
            <p className="menu_name">{t('panel.menu.license')}</p>
          </NavLink>
        )}
        {subMenu.policy && subMenu.policy !== 0 ? (
          <NavLink
            to={`policy/project/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            onClick={() => {
              props.state.user.setTransientNavigationState({ navigatedFromTab: true });
            }}
            className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
            end
          >
            <p className="icon">
              <img className="on" src={policyIconOn} alt="Policy" />
              <img className="off" src={policyIconOff} alt="Policy" />
            </p>
            <p className="menu_name">{t('panel.menu.policy')}</p>
          </NavLink>
        ) : (
          <NavLink
            to={`policy/project/${location.pathname && location.pathname.replace(
              /^\D+/g,
              ''
            )}`}
            className={() => { return undefined; }}
            style={{ pointerEvents: 'none' }}
            end
          >
            <p className="icon">
              <img className="on" src={policyIconOn} alt="Policy" />
              <img className="off" src={policyIconOff} alt="Policy" />
            </p>
            <p className="menu_name">{t('panel.menu.policy')}</p>
          </NavLink>
        )}
      </nav>
    );
  }
}
export default WithRouter(withTranslation()(HeaderLinkDetail));
